(function() {
  // let tbs_nodes = document.querySelectorAll('.accordion-wrap');
  // for (let i = 0; i < tbs_nodes.length; i++) {
  //     if (tbs_nodes[i].classList.contains('accordion-item')) {
  //       tbs_nodes[i].querySelector('button.collapsible-trigger').classList.add('is-open');
  //       tbs_nodes[i].querySelector('.collapsible-content').classList.add('is-open'); 
  // 	  break;
  //    }
  // }
})();

document.addEventListener("DOMContentLoaded", function() {

  // Scroll to the section after it has been filtered
  var sortByElement = document.querySelector("#SortBy");
  var queryParams = new URLSearchParams(window.location.search);
  var sortParam = queryParams.get("sort_by");
  if (sortByElement && sortParam) {
    var offset = 30;
    var scrollToPosition = sortByElement.offsetTop - offset;
    window.scrollTo({
      top: scrollToPosition,
      behavior: "smooth"
    });
  }

  
});